import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';
import '../styles/NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO 
        title="404 - Page Not Found | BookMyCamera"
        description="The page you are looking for could not be found. Return to BookMyCamera homepage."
        noindex={true}
      />
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="not-found-icon">
            <span className="error-code">404</span>
          </div>
          <h1 className="not-found-title">Page Not Found</h1>
          <p className="not-found-description">
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>
          <div className="not-found-actions">
            <button 
              className="not-found-btn primary" 
              onClick={() => navigate('/')}
            >
              <Home size={20} />
              Go to Homepage
            </button>
            <button 
              className="not-found-btn secondary" 
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={20} />
              Go Back
            </button>
          </div>
          <div className="not-found-links">
            <p>Or visit our popular pages:</p>
            <div className="popular-links">
              <a href="/event-packages">Event Packages</a>
              <a href="/products">Rental Gears</a>
              <a href="/services">Services</a>
              <a href="/contact">Contact Us</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;

